import { Skeleton } from './ui/Skeleton';

export interface PageLoadingStateProps {
    /** What the page is waiting on, or the load error to show in its place. */
    message: string;
}

/**
 * Loading-screen body for a page still waiting on its data.
 *
 * The message stays as real text rather than a skeleton alone, for two reasons:
 * a failed load must be able to show its error in the same spot, and E2E specs
 * wait for this text to disappear to know the page has mounted. A skeleton-only
 * screen lets those waits pass instantly on a page that never finished loading.
 */
export function PageLoadingState({ message }: PageLoadingStateProps) {
    return (
        <div data-testid="page-loading-state" className="flex flex-col items-center gap-3 w-full max-w-md px-4">
            <span className="text-title text-content-muted">{message}</span>
            <Skeleton variant="block" className="w-full h-24" />
            <Skeleton variant="block" className="w-full h-24" />
        </div>
    );
}

export default PageLoadingState;